export const USER = 'USER';
export const CONTACT = 'CONTACT';
export const COMPANY = 'COMPANY';
export const UNKNOWN_PARTICIPANT = 'UNKNOWN_PARTICIPANT';